import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App.jsx";

import "./features/admin/index.css";
import "./css/main.css";

// Detect stale assets after redeployment and reload once to get fresh version
window.addEventListener(
	"error",
	(event) => {
		const target = event.target;
		if (
			target &&
			(target.tagName === "LINK" || target.tagName === "SCRIPT") &&
			!sessionStorage.getItem("assetsReloaded")
		) {
			sessionStorage.setItem("assetsReloaded", "true");
			window.location.reload();
		}
	},
	true
);

ReactDOM.createRoot(document.getElementById("root")).render(
	<React.StrictMode>
		<App />
	</React.StrictMode>
);
